import React from 'react';
import Text from '../text';
import { SIZES, APPEARANCES, TYPES, ALIGN } from './constants';
const Label = ({
  align = ALIGN.left,
  for: labelFor,
  size = SIZES.medium,
  appearance = APPEARANCES.highEmphasis,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type
  weight = null,
  children,
}) => {
  const labelConfig = {
    for: labelFor,
  };

  return (
    <Text
      type={TYPES.label}
      labelConfig={labelConfig}
      align={align}
      size={size}
      appearance={appearance}
      weight={weight}
    >
      {children}
    </Text>
  );
};

export default Label;
